export const handleOnClick=(e,onClick,args)=>{null==e||e.stopPropagation(),null==e||e.preventDefault(),null==onClick||onClick(args)};